import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouteReuseStrategy } from "@angular/router";
import { SplashScreen } from "@awesome-cordova-plugins/splash-screen/ngx";
import { StatusBar } from "@awesome-cordova-plugins/status-bar/ngx";
import { IonicModule, IonicRouteStrategy, isPlatform } from "@ionic/angular";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { ServiceWorkerModule } from "@angular/service-worker";
import { GooglePlus } from "@awesome-cordova-plugins/google-plus/ngx";
import { NgChartsModule } from "ng2-charts";

import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HTTPInterceptor } from "./interceptors/requestInterceptor";
import { AnalyticsService } from "./shared/analytics.service";
import { ExerciseService } from "./shared/exercise.service";
import { SpinnerService } from "./shared/spinner.service";
import { WorkoutService } from "./shared/workout.service";
import { AuthService } from "./shared/auth.service";
import { UserService } from "./shared/user.service";
import { IonicStorageModule } from '@ionic/storage-angular';
import { DailyStreakService } from "./shared/daily-streak.service";
import { OnboardingService } from "./shared/onboarding.service";
import { ProgressService } from "./shared/progress.service";
import { Validation } from "./shared/helpers";
import { PushService } from "./shared/push.service";
//import { Appsflyer } from '@awesome-cordova-plugins/appsflyer/ngx';
import { ApprateService } from "./shared/apprate.service";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
//import { AdMob } from '@admob-plus/ionic/ngx';
import { AnswerService } from "./shared/answers.service";
import { AssignmentService } from "./shared/assignments.service";
import { ProService } from "./shared/pro.service";
import { FirebaseInitService } from "./shared/firebase-init.service";
import { PurchaseService } from "./shared/purchase.service";
@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        NgChartsModule,
        BrowserAnimationsModule,
        HttpClientModule,
        IonicModule.forRoot({
            _forceStatusbarPadding: isPlatform("android")
        }),
        AppRoutingModule,
        BrowserAnimationsModule,
        IonicStorageModule.forRoot(),
        ServiceWorkerModule.register("ngsw-worker.js", { enabled: environment.production }),
    ],
    providers: [
        // HTTP Interceptor - fixed for Android
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HTTPInterceptor,
            multi: true
        },
        StatusBar,
        SplashScreen,
        GooglePlus,
        UserService,
        ExerciseService,
        //Adjust,
        //Appsflyer,
        InAppBrowser,
        ApprateService,
        AnalyticsService,
        PushService,
        SpinnerService,
        ProService,
        ProgressService,
        AuthService,
        WorkoutService,
        OnboardingService,
        Validation,
        DailyStreakService,
        //SignInWithApple,
        AnswerService,
        AssignmentService,
        FirebaseInitService,
        PurchaseService,
        //AdMob,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
